<template>
  <div>
    <router-view></router-view>
  </div>
</template>
<script type="text/javascript">
export default {
  name: 'Adm'
}

</script>



// WEBPACK FOOTER //
// src/Adm/containers/Adm.vue